import { ButtonPrimary, ButtonSecondary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import IntroCard from 'components/IntroCard'
import { RowBetween, RowFixed } from 'components/Row'
import { LoadingRows } from 'pages/Pool/styleds'
import React, { useContext } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import styled, { ThemeContext } from 'styled-components'
import { HideSmall, TYPE } from 'theme'
import { CancelButton, GridContainerForCard, InputText, InputTextWrapper, LeverageItem, TableWrapper } from './styled'
import { useToken } from 'hooks/Tokens'
import DoubleCurrencyLogo from 'components/DoubleLogo'
import { Currency, WETH9 } from '@uniswap/sdk-core'
import CurrencyLogo from 'components/CurrencyLogo'
import { formatUnits } from 'ethers/lib/utils'
import { roundToDecimalPlace } from 'utils/data'
import { API_POOL_BASE_URL } from 'constants/links'
import { CURRENT_CHAIN } from '@hyperswap/addresses'
import { Helmet } from 'react-helmet'
import Tag from 'components/Tag'
import { formattedFeeAmount } from 'utils'
import axios from 'axios'
import MetricsTVL from './MetricsTVL'
import TagButton from 'components/TagButton'
import QuestionHelper from 'components/QuestionHelper'
import Metrics from './Metrics'
import KeikoLogo from '../../assets/keiko.jpg'

const PageWrapper = styled(AutoColumn)`
  max-width: 1400px;
  padding: 0 12px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
      padding: 0;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
        padding: 0;
  `};
`
const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    flex-direction: column-reverse;
  `};
`
const ButtonRow = styled(RowFixed)`
  & > *:not(:last-child) {
    margin-right: 8px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  `};
`
const NoLiquidity = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  max-width: 300px;
  min-height: 25vh;
`
const ResponsiveButtonPrimary = styled(ButtonPrimary)`
  border-radius: 12px;
  padding: 6px 8px;
  width: fit-content;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex: 1 1 auto;
    width: 49%;
  `};
`

const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
`

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 8px;
  justify-content: center;
  button {
    width: 46px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: repeat(1, 1fr); 
  `};
`

interface Reserves {
  reserve0: string
  reserve1: string
}

interface Token {
  tokenAddress: string
  tokenName: string
  tokenSymbol: string
  tokenDecimal: number
}

interface Pair {
  pairAddress: string
  token0: Token
  token1: Token
  reserves: Reserves
}

const TOTAL_PER_PAGE = 15

const PoolLogo: React.FC<{ tokenA: string; tokenB: string; size?: number }> = ({ tokenA, tokenB, size }) => {
  const currencyA = useToken(tokenA)
  const currencyB = useToken(tokenB)

  return (
    <DoubleCurrencyLogo size={size ? size : 20} currency0={currencyA as Currency} currency1={currencyB as Currency} />
  )
}

const TokenLogo: React.FC<{ token: string }> = ({ token }) => {
  const currency = useToken(token)

  return <CurrencyLogo size={'20px'} currency={currency as Currency} />
}

const FILTER_QUERY_PARAM = 'filter'
const ExplorePools = () => {
  const history = useHistory()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const filter = queryParams.get(FILTER_QUERY_PARAM) || ''
  const [lpLoading, setLpLoading] = React.useState(false)
  const [data, setData] = React.useState<Pair[]>([])
  const theme = useContext(ThemeContext)
  const [currentPage, setCurrentPage] = React.useState(0)
  const [pageCount, setPageCount] = React.useState<number>(1)
  const [searchTerm, setSearchTerm] = React.useState('')
  const [sortBy, setSortBy] = React.useState<'tvl' | 'apr' | 'volume'>('tvl')

  const isLeverage = filter === 'leverage'

  React.useEffect(() => {
    setCurrentPage(0)
  }, [filter])

  React.useEffect(() => {
    const fetchDataForLeveragePool = async () => {
      setLpLoading(true)

      const urls = [
        `${API_POOL_BASE_URL}/api/pairs?version=v3&token0=0x1bEe6762F0B522c606DC2Ffb106C0BB391b2E309&token1=0x5555555555555555555555555555555555555555&fee=10000`,
        `${API_POOL_BASE_URL}/api/pairs?version=v2&token0=0x5555555555555555555555555555555555555555&token1=0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463`,
        `${API_POOL_BASE_URL}/api/pairs?version=v3&token0=0x5555555555555555555555555555555555555555&token1=0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463&fee=3000`,
      ]

      try {
        setData([])

        const requests = urls.map((url) => axios.get(url))
        const responses = await Promise.all(requests)
        setCurrentPage(0)

        let pairs: any[] = []
        responses.forEach((response: any) => {
          if (response?.data?.success) {
            pairs = [...pairs, response?.data?.data?.pairs].flat()
          }
        })

        setData(pairs)
        const tableTopElement = document.getElementById('table-top')
        if (tableTopElement) {
          const yOffset = -15
          const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    if (isLeverage) {
      fetchDataForLeveragePool()
    }
  }, [isLeverage])

  React.useEffect(() => {
    const fetchData = async (page: number, tokenName = '', sortBy = '') => {
      setLpLoading(true)
      try {
        setData([])
        const response = await axios.get(`${API_POOL_BASE_URL}/api/pairs`, {
          params: {
            ...(sortBy && sortBy !== 'tvl' ? { sort: sortBy } : {}),
            page: page,
            maxPerPage: TOTAL_PER_PAGE,
            ...(tokenName && tokenName.length > 0 ? { tokenName } : {}),
            ...((filter && filter === 'v2') || 'v3' ? { version: filter } : {}),
          },
        })

        if (response.data.success) {
          setData(response.data.data.pairs)
          setPageCount(response.data.data.pageCount)
          const tableTopElement = document.getElementById('table-top')
          if (tableTopElement && response.data.data.pairs.length > 0) {
            const yOffset = -15
            const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

            window.scrollTo({ top: y, behavior: 'smooth' })
          }
        } else {
          setData([])
          throw new Error('Failed to fetch data')
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    const delayDebounceFn = setTimeout(() => {
      if (!isLeverage) {
        fetchData(currentPage, searchTerm, sortBy)
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, currentPage, sortBy, filter, isLeverage])

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < pageCount) {
      setCurrentPage(newPage)
    }
  }

  const switchFilter = (value: string) => {
    const params = new URLSearchParams(location.search)
    if (value) {
      params.set(FILTER_QUERY_PARAM, value)
    } else {
      params.delete(FILTER_QUERY_PARAM)
    }
    history.push({ search: params.toString() })
  }

  return (
    <>
      <Helmet>
        <title>Explore Pools | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Discover all liquidity pools on HyperSwap Exchange. Built on Hyperliquid, our pools offer optimal earning opportunities for liquidity providers."
        />
        <meta
          name="keywords"
          content="HyperSwap pools, liquidity pools, Hyperliquid blockchain, DEX pools, DeFi, decentralized finance, Hyperliquid EVM"
        />
        <meta property="og:title" content="Explore Pools | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Explore and invest in liquidity pools on HyperSwap Exchange, leveraging Hyperliquid's fast and secure EVM."
        />
        <meta property="og:url" content={`${window.location.origin}/#/explore/explore-pools`} />
      </Helmet>
      <PageWrapper>
        <AutoColumn gap="lg" justify="center">
          <div style={{ width: '100%' }}>
            <IntroCard variant={1} key="Explore-pools">
              <h1>Explore Pools</h1>
              <p>Discover all Liquidity Pools.</p>
            </IntroCard>
          </div>

          <AutoColumn gap="lg" style={{ width: '100%' }}>
            <GridContainer>
              <MetricsTVL />
              <Metrics />
            </GridContainer>
            <TitleRow padding={'0'} id="table-top">
              <HideSmall>
                <TYPE.mediumHeader>
                  {filter === 'v2' && 'Standard AMM Pool Overview'}
                  {filter === 'v3' && 'Concentrated Pool Overview'}
                  {(filter === '' || filter === undefined) && 'Pool Overview'}
                </TYPE.mediumHeader>
              </HideSmall>
              <ButtonRow>
                <ResponsiveButtonPrimary id="join-pool-button" as={Link} to="/add/HYPE">
                  + New Position
                </ResponsiveButtonPrimary>
              </ButtonRow>
            </TitleRow>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              <TagButton
                active={filter === 'leverage'}
                onClick={() => {
                  switchFilter('leverage')
                }}
                style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-rocket"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3" />
                  <path d="M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3" />
                  <path d="M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                </svg>
                Leveraged Pools
              </TagButton>
              <TagButton
                active={filter === 'v3'}
                onClick={() => {
                  switchFilter('v3')
                }}
                style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
              >
                Concentrated Liquidity
              </TagButton>
              <TagButton
                active={filter === 'v2'}
                onClick={() => {
                  switchFilter('v2')
                }}
                style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
              >
                Standard AMM
              </TagButton>
              <TagButton
                active={filter === '' || filter === undefined}
                onClick={() => {
                  switchFilter('')
                }}
                style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
              >
                All
              </TagButton>
            </div>
            {!isLeverage && (
              <InputTextWrapper>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="grey"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-search"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                  <path d="M21 21l-6 -6" />
                </svg>
                <InputText
                  type="text"
                  placeholder="Search by token name..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    setCurrentPage(0)
                  }}
                />

                {searchTerm.length > 0 && (
                  <CancelButton
                    onClick={() => {
                      setSearchTerm('')
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-x"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M18 6l-12 12" />
                      <path d="M6 6l12 12" />
                    </svg>
                  </CancelButton>
                )}
              </InputTextWrapper>
            )}
            <>
              {lpLoading ? (
                <MainContentWrapper>
                  <LoadingRows>
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </LoadingRows>
                </MainContentWrapper>
              ) : data.length > 0 ? (
                <div style={{ maxWidth: '100%', overflow: 'auto' }}>
                  {isLeverage ? (
                    <GridContainerForCard>
                      {data.map((pool: any) => {
                        const isHypurrFiPoints =
                          ((pool.token0.token0Symbol === 'WHYPE' || pool.token1.token1Symbol === 'WHYPE') &&
                            (pool.token0.token0Symbol === 'USDXL' || pool.token1.token1Symbol === 'USDXL')) ||
                          ((pool.token0.token0Symbol === 'KEI' || pool.token1.token1Symbol === 'KEI') &&
                            (pool.token0.token0Symbol === 'USDXL' || pool.token1.token1Symbol === 'USDXL'))
                        const isKEIPoints = pool.token0.token0Symbol === 'KEI' || pool.token1.token1Symbol === 'KEI'
                        const isVolumeIncreasing =
                          pool.prevH24 && pool.h24 ? parseFloat(pool.h24) - parseFloat(pool.prevH24) > 0 : null

                        const volumeIncreasingIcon =
                          isVolumeIncreasing !== null ? (
                            isVolumeIncreasing ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#4AFB39"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-trending-up"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 17l6 -6l4 4l8 -8" />
                                <path d="M14 7l7 0l0 7" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="red"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-trending-down"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 7l6 6l4 -4l8 8" />
                                <path d="M21 10l0 7l-7 0" />
                              </svg>
                            )
                          ) : (
                            <></>
                          )

                        const addV2LPRoute = `/add${pool.version === 'v3' ? '/' : '/v2/'}${
                          pool.token0.token0Address === WETH9[CURRENT_CHAIN].address
                            ? 'HYPE'
                            : pool.token0.token0Address
                        }/${
                          pool.token1.token1Address === WETH9[CURRENT_CHAIN].address
                            ? 'HYPE'
                            : pool.token1.token1Address
                        }`

                        const swapRoute = `/swap${pool.version === 'v3' ? '/' : '/v2/'}?inputCurrency=${
                          pool.token0.token0Address === WETH9[CURRENT_CHAIN].address
                            ? 'HYPE'
                            : pool.token0.token0Address
                        }&outputCurrency=${
                          pool.token1.token1Address === WETH9[CURRENT_CHAIN].address
                            ? 'HYPE'
                            : pool.token1.token1Address
                        }`

                        return (
                          <LeverageItem key={pool.token0.token0Address}>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginLeft: '30px',
                                marginBottom: '8px',
                              }}
                            >
                              <PoolLogo
                                tokenA={pool.token0.token0Address}
                                tokenB={pool.token1.token1Address}
                                size={48}
                              />
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  flexDirection: 'column',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                <span style={{ fontWeight: 500, fontSize: 16, textAlign: 'left', marginRight: 'auto' }}>
                                  {pool.token0.token0Symbol === 'WHYPE' ? 'HYPE' : pool.token0.token0Symbol} /{' '}
                                  {pool.token1.token1Symbol === 'WHYPE' ? 'HYPE' : pool.token1.token1Symbol}
                                </span>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    gap: '8px',
                                    flexWrap: 'wrap',
                                  }}
                                >
                                  <Tag variant={pool.version === 'v3' ? 2 : 1}>
                                    <div style={{ padding: '0 2px' }}>{pool.version === 'v3' ? 'v3' : 'v2'}</div>
                                  </Tag>

                                  <Tag variant={1}>
                                    <div style={{ padding: '0 2px' }}>
                                      {pool.fee ? formattedFeeAmount(pool.fee) : '0.3'}%
                                    </div>
                                  </Tag>
                                  <Tag variant={1}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 1695.06 1200.04"
                                      fill="#4AFC38"
                                    >
                                      <path
                                        className="cls-1"
                                        d="m624.44,12.53C390.27-54.51,125.14,154.18,32.26,478.64c-92.88,324.46,21.66,641.83,255.83,708.87,234.17,67.04,499.3-141.65,592.18-466.11,92.88-324.46-21.66-641.83-255.83-708.87Zm-39.45,304.79c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
                                      />
                                      <path
                                        className="cls-1"
                                        d="m1470.12,266.02c-182.84-52.34-389.86,110.6-462.38,363.94-72.52,253.34,16.91,501.15,199.75,553.49,182.84,52.34,389.86-110.6,462.38-363.94,72.52-253.34-16.91-501.15-199.75-553.49Zm-26.94,293.29c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
                                      />
                                    </svg>
                                    Points
                                  </Tag>
                                  {isHypurrFiPoints && (
                                    <Tag variant={3}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="68"
                                        height="30"
                                        viewBox="0 0 68 30"
                                        fill="none"
                                        style={{ width: '20px' }}
                                      >
                                        <g clipPath="url(#clip0_5_2746)">
                                          <path
                                            d="M67.0578 13.0404C66.4812 12.3161 65.5848 11.5853 64.445 10.8891C64.6941 10.8604 64.9395 10.8055 65.1715 10.7155C66.4196 10.2306 66.9956 9.43534 67.0975 8.05619C67.1693 7.087 66.6677 6.05241 65.6473 5.06378C64.593 4.04277 62.0101 2.15034 56.5546 0.947326C51.8346 -0.0937408 46.2872 -0.28067 40.5115 0.405971C31.4797 1.48004 24.8332 4.20594 20.8477 6.30381C20.1734 6.65854 19.5519 7.0068 18.982 7.3421C18.631 6.7335 18.0987 6.13446 17.2904 5.71927C15.7444 4.92528 13.224 4.99129 11.5989 6.67798C10.9329 7.36924 10.5995 8.1657 10.4347 8.73944C9.92833 8.3952 9.11975 8.00746 8.04927 8.00746C5.60186 8.00746 3.94228 9.52942 3.38308 11.0375C2.79397 12.6273 3.13278 13.9947 3.42612 14.7326C2.67065 14.9158 1.41398 15.4186 0.637146 16.7864C-0.655543 19.0622 0.175929 21.5463 1.72685 22.6333C2.87089 23.4353 4.38213 23.4149 5.43948 23.2604C5.41597 23.8776 5.43307 24.8983 5.69008 25.9629C6.245 28.2606 7.64178 29.6314 9.72962 29.9266C10.084 29.9766 10.4182 29.9997 10.7345 29.9997C13.0412 29.9997 14.3784 28.7711 15.3875 27.8439C15.7801 27.483 16.1192 27.1714 16.4397 26.9978C16.7709 26.8182 17.6173 26.8105 18.5132 26.8022C20.7582 26.7812 24.1507 26.7497 25.4034 23.9248C25.6152 23.447 25.7428 22.9806 25.8038 22.5293C28.591 22.0518 32.5774 21.6311 37.0656 21.9578C42.2803 22.3378 46.112 24.1056 49.1907 25.5258C51.2229 26.4635 52.8285 27.2041 54.2268 27.2427C54.3019 27.2448 54.3758 27.2458 54.4484 27.2458C55.7084 27.2458 56.5948 26.9302 57.3024 26.2349C57.8857 25.6621 58.2206 24.6991 58.14 23.8326C58.9949 24.3147 59.8975 24.5017 60.7379 24.5017C61.6426 24.5017 62.4747 24.286 63.0958 23.9921C63.8797 23.621 64.503 22.8156 64.763 21.8375C65.0707 20.6807 64.8339 19.4163 64.0982 18.2543C64.3504 18.2913 64.5994 18.3114 64.8415 18.3114C66.0154 18.3114 67.0374 17.8832 67.5682 17.0754C68.1762 16.15 68.2541 14.5432 67.0572 13.0394L67.0578 13.0404ZM21.2906 7.07651C25.2053 5.0206 31.7352 2.34806 40.6146 1.29219C49.1345 0.278884 60.4113 1.22865 65.0362 5.70786C65.8601 6.50585 66.2682 7.2946 66.2169 7.98957C66.1412 9.01274 65.7719 9.52603 64.8543 9.8823C63.717 10.3243 61.968 9.59728 61.9509 9.58988C61.9414 9.58587 61.9313 9.58433 61.9219 9.58093C60.8444 9.10281 59.6561 8.65986 58.3887 8.27027C54.9563 7.21501 49.249 6.01324 41.5517 6.28129C34.0572 6.54256 27.9243 8.12406 24.1885 9.36131C24.1351 9.32275 24.0832 9.28265 24.0273 9.24717C23.0176 8.60372 21.3089 8.21228 19.5834 9.01768C19.5385 8.76998 19.4661 8.47355 19.3544 8.15737C19.9432 7.8085 20.5879 7.44574 21.2909 7.07651H21.2906ZM24.8783 22.6978C24.8167 22.9871 24.7242 23.2749 24.5975 23.5602C23.5762 25.8632 20.7643 25.8891 18.5049 25.9101C17.4097 25.9203 16.545 25.9283 16.0221 26.2115C15.6058 26.4373 15.2111 26.7997 14.7932 27.1838C13.7182 28.1715 12.3803 29.4004 9.85171 29.0429C5.70992 28.4571 6.32986 23.0075 6.35825 22.7764C6.37626 22.633 6.32406 22.4899 6.21906 22.3921C6.13664 22.3156 6.02981 22.2745 5.92023 22.2745C5.8897 22.2745 5.85888 22.2776 5.82835 22.2844C5.1263 22.4353 3.37026 22.6999 2.22958 21.9004C0.692394 20.8229 0.60357 18.6378 1.40269 17.2308C2.30284 15.6463 4.03232 15.5247 4.10405 15.5204C4.26095 15.5121 4.40136 15.4202 4.47339 15.2792C4.54543 15.1382 4.5378 14.9692 4.45325 14.8353C4.44348 14.8199 3.4948 13.2791 4.20967 11.3509C4.54696 10.4406 5.73525 8.90015 8.04897 8.90015C9.52175 8.90015 10.3544 9.81321 10.3877 9.85053C10.5049 9.98471 10.6902 10.0347 10.8581 9.97824C11.026 9.92179 11.1444 9.7694 11.1587 9.5908C11.1597 9.57785 11.2726 8.29556 12.2314 7.30077C13.7243 5.75166 15.8811 5.99689 16.8902 6.51511C17.5239 6.84054 17.9445 7.31465 18.2241 7.79955C18.3865 8.08087 18.5007 8.36528 18.5819 8.62685C18.7647 9.21694 18.7769 9.68859 18.7775 9.72992C18.779 9.89156 18.8673 10.0396 19.0077 10.117C19.1481 10.1945 19.319 10.1889 19.4545 10.1029C20.7741 9.2626 22.1272 9.3539 23.0658 9.7475C23.2456 9.82277 23.4104 9.90914 23.5567 10.0023C23.7175 10.1047 23.8656 10.2278 24.0026 10.3632C24.8347 11.1846 25.2321 12.5212 25.1943 13.3134C25.1903 13.3991 25.1836 13.4824 25.1747 13.5638C25.1338 13.9454 25.0429 14.2776 24.9186 14.5673C24.2468 16.1361 22.593 16.4458 22.5075 16.4606C22.3329 16.4905 22.1928 16.6232 22.1519 16.7971C22.1107 16.9717 22.1773 17.1547 22.3207 17.2608C22.3278 17.266 22.8268 17.6402 23.3885 18.2735C23.5887 18.4993 23.7963 18.7584 23.9931 19.0455C24.0191 19.0835 24.0456 19.1208 24.0713 19.16C24.6488 20.0394 24.9452 20.9139 24.9647 21.7755C24.9717 22.0848 24.9434 22.3924 24.8783 22.6981V22.6978ZM56.6873 25.5955C56.1086 26.164 55.4032 26.383 54.2512 26.3509C53.0321 26.317 51.4989 25.6097 49.5576 24.7142C46.5802 23.3406 42.5026 21.4593 37.1291 21.0678C32.6635 20.7421 28.6767 21.1459 25.8389 21.6203C25.7809 20.566 25.3866 19.6199 24.9009 18.8376C36.9625 16.1799 48.0799 17.5877 56.7063 22.9205C57.1076 23.1895 57.2297 23.6022 57.26 23.9032C57.3198 24.4986 57.0787 25.2102 56.6867 25.5952L56.6873 25.5955ZM63.9108 21.6067C63.7204 22.3233 63.2646 22.9279 62.7219 23.1845C61.6682 23.6833 59.8923 23.9147 58.3558 22.9254C58.2859 22.8804 58.1995 22.823 58.0966 22.7548C57.7963 22.5552 57.4922 22.3609 57.1858 22.1712C57.1788 22.1666 57.173 22.161 57.1659 22.1567C57.1605 22.153 57.154 22.1512 57.1485 22.1478C48.2401 16.6488 36.7644 15.2332 24.3454 18.0489C24.0395 17.663 23.7337 17.341 23.4785 17.0951C24.433 16.696 25.5612 15.8292 25.9461 14.2696C29.2747 13.3454 34.6564 12.2347 41.3955 12.1921C47.9465 12.1495 53.0333 13.4352 56.1474 14.5201C60.3337 15.9785 62.5885 17.6137 63.2469 18.5705C63.9316 19.5653 64.1675 20.6434 63.9114 21.6067H63.9108ZM66.8332 16.5825C66.2975 17.3974 64.7069 17.771 62.9566 17.0047C61.5651 15.8548 59.226 14.6487 56.4346 13.6761C53.2555 12.5684 48.0655 11.2581 41.3893 11.2994C34.8124 11.341 29.4929 12.3914 26.0767 13.3115C26.1033 12.4635 25.7464 11.0816 24.9192 10.0594C28.6233 8.86869 34.4787 7.42076 41.5826 7.17337C54.7851 6.71283 64.0259 10.6544 66.3701 13.5999C67.2822 14.7459 67.2498 15.9495 66.8335 16.5828L66.8332 16.5825Z"
                                            fill="#231F20"
                                          />
                                          <path
                                            d="M9.92078 14.9215C10.3063 14.4696 10.4946 13.8927 10.451 13.2977C10.4073 12.7027 10.1369 12.1601 9.68971 11.7705C9.24223 11.3809 8.67143 11.1909 8.08293 11.2347C6.86716 11.3257 5.95144 12.3995 6.0418 13.6278C6.08544 14.2228 6.35589 14.7651 6.80306 15.155C7.20811 15.5075 7.7139 15.6969 8.24288 15.6969C8.29843 15.6969 8.35398 15.6948 8.40984 15.6908C8.99865 15.6467 9.53556 15.3734 9.92108 14.9215H9.92078ZM9.26299 13.9214H9.26024C9.05268 13.9214 8.88327 13.7521 8.88174 13.5417C8.88022 13.4667 8.85183 13.2348 8.74103 13.0941C8.56643 12.8726 8.36955 12.8396 8.36131 12.8384C8.15344 12.8168 8.00662 12.6293 8.02799 12.4192C8.04935 12.2091 8.23982 12.0568 8.44769 12.0783C8.49897 12.0836 8.96019 12.1444 9.33319 12.6175C9.62622 12.9896 9.63843 13.4809 9.63874 13.5358C9.64026 13.7471 9.47207 13.9196 9.26299 13.9211V13.9214Z"
                                            fill="#FFB1B5"
                                          />
                                          <path
                                            d="M13.6116 12.5848C14.0166 12.9373 14.5224 13.1267 15.0514 13.1267C15.107 13.1267 15.1625 13.1246 15.2184 13.1206C15.8072 13.0765 16.3441 12.8032 16.7296 12.3513C17.1151 11.8994 17.3035 11.3225 17.2598 10.7275C17.233 10.3626 17.1203 10.0177 16.9344 9.71544C16.8172 9.52481 16.6716 9.35114 16.4985 9.2003C16.4402 9.14941 16.3795 9.10252 16.3172 9.05841C15.9018 8.76537 15.4033 8.62594 14.8918 8.6645C13.676 8.7555 12.7603 9.82926 12.8506 11.0576C12.8943 11.6526 13.1647 12.1949 13.6119 12.5848H13.6116ZM14.8921 9.90915C14.922 9.70001 15.1146 9.55473 15.3209 9.58557C15.3777 9.5939 15.4479 9.61149 15.5236 9.63863C15.7559 9.7213 16.0453 9.90237 16.2229 10.2293C16.2351 10.2519 16.2492 10.2719 16.2605 10.2957C16.512 10.8392 16.3349 11.3154 16.3142 11.3682C16.2547 11.5169 16.113 11.6072 15.9632 11.6072C15.9158 11.6072 15.8679 11.5983 15.8215 11.5792C15.6277 11.4999 15.5343 11.2772 15.6124 11.0813C15.6134 11.0788 15.6714 10.9101 15.6063 10.7022C15.5978 10.6751 15.588 10.6476 15.5749 10.6195C15.4684 10.3891 15.215 10.3425 15.2126 10.3422C15.0761 10.3222 14.9687 10.2306 14.9189 10.1106C14.8933 10.0489 14.882 9.9801 14.8924 9.90885L14.8921 9.90915Z"
                                            fill="#FFB1B5"
                                          />
                                          <path
                                            d="M4.49319 17.0992C3.97398 17.138 3.50086 17.3789 3.16082 17.7775C2.82078 18.176 2.65473 18.6847 2.69319 19.2094C2.73165 19.7341 2.97005 20.2122 3.36442 20.5558C3.72155 20.8667 4.1675 21.0336 4.63391 21.0336C4.68274 21.0336 4.73189 21.0318 4.78103 21.0281C5.30024 20.9892 5.77336 20.7483 6.1134 20.3498C6.45344 19.9512 6.61949 19.4426 6.58072 18.9179C6.50136 17.8345 5.56336 17.0193 4.49289 17.0992H4.49319ZM5.8335 19.4237C5.81396 19.5354 5.74803 19.6264 5.65982 19.6819C5.60121 19.7186 5.53314 19.7402 5.4611 19.7402C5.43943 19.7402 5.41746 19.7384 5.39517 19.7344C5.18944 19.698 5.05178 19.4996 5.0878 19.2917C5.0878 19.2889 5.11618 19.0647 4.95288 18.8614C4.83323 18.7124 4.651 18.6964 4.64306 18.6958C4.43428 18.6871 4.27494 18.5091 4.28349 18.2982C4.29204 18.0872 4.47335 17.9246 4.6803 17.9317C4.73341 17.9339 5.20776 17.965 5.54047 18.379C5.71995 18.6026 5.79687 18.8355 5.82739 19.0255C5.86127 19.2362 5.83838 19.3935 5.83319 19.4237H5.8335Z"
                                            fill="#FFB1B5"
                                          />
                                          <path
                                            d="M22.9382 14.2782C23.0964 13.967 23.1763 13.6107 23.1492 13.2372C23.1107 12.7125 22.8723 12.2344 22.4779 11.8907C22.1248 11.5829 21.6834 11.4175 21.2228 11.4142C21.1691 11.4138 21.1154 11.4142 21.0613 11.4182C20.7582 11.441 20.4716 11.5345 20.217 11.6859C20.0357 11.7939 19.8703 11.9305 19.729 12.0965C19.3889 12.495 19.2229 13.0034 19.2616 13.5281C19.3001 14.0528 19.5385 14.5309 19.9329 14.8745C20.29 15.1854 20.7359 15.3523 21.2026 15.3523C21.2515 15.3523 21.3006 15.3505 21.3498 15.3468C21.4514 15.3391 21.55 15.3215 21.6465 15.2986C22.2154 15.1651 22.6821 14.7829 22.9389 14.2776L22.9382 14.2782ZM22.267 13.9161C22.2139 14.0759 22.0665 14.1764 21.9084 14.1764C21.8684 14.1764 21.8275 14.17 21.7875 14.1564C21.5894 14.0888 21.4829 13.872 21.5497 13.6718C21.5753 13.595 21.6098 13.4386 21.5525 13.2575C21.5152 13.1394 21.4346 13.0444 21.3128 12.9756C21.1306 12.8723 21.0659 12.6391 21.1682 12.4549C21.2704 12.2708 21.5012 12.2054 21.6834 12.3087C21.8855 12.4234 22.1519 12.6409 22.2731 13.025C22.39 13.3945 22.3342 13.7134 22.2667 13.9161H22.267Z"
                                            fill="#FFB1B5"
                                          />
                                          <path
                                            d="M19.8402 19.2491C19.8402 19.2491 19.8399 19.2482 19.8396 19.2479C19.3881 18.1146 18.5759 17.286 17.491 16.8517C15.7786 16.1663 13.7677 16.5778 12.4567 17.1919C9.24652 18.6954 8.78897 21.4339 9.26453 22.9075C9.6003 23.9476 10.3741 24.5602 11.3011 24.5602C11.4449 24.5602 11.5926 24.5454 11.7428 24.5152C12.6194 24.3388 13.1899 23.9553 13.7418 23.5843C14.5137 23.0654 15.3116 22.5287 17.1248 22.4016C18.3997 22.3121 19.2681 21.9269 19.7059 21.256C19.9207 20.9265 20.0218 20.5317 20.0074 20.102C19.9986 19.8343 19.9452 19.5532 19.846 19.2661C19.8441 19.2605 19.842 19.255 19.8399 19.2494L19.8402 19.2491ZM17.2063 19.2802C16.5066 18.5615 15.4188 18.5254 15.4078 18.5251C15.1993 18.5199 15.0339 18.345 15.0384 18.1343C15.043 17.9236 15.2106 17.758 15.4237 17.7604C15.4804 17.7617 16.8259 17.799 17.7456 18.7438C17.8921 18.8944 17.8903 19.1365 17.7413 19.2846C17.6678 19.358 17.5716 19.3944 17.4761 19.3944C17.3805 19.3944 17.2804 19.3561 17.2063 19.2802ZM18.2099 20.8321C18.1916 20.8349 18.1733 20.8361 18.1549 20.8361C17.97 20.8361 17.8082 20.6989 17.781 20.5086C17.7691 20.4253 17.7535 20.3435 17.7349 20.2658C17.6858 20.0604 17.8106 19.854 18.0139 19.8043C18.2169 19.7547 18.4217 19.8808 18.4706 20.0863C18.4947 20.1871 18.5145 20.2923 18.5301 20.3987C18.56 20.6079 18.4168 20.8019 18.2099 20.8321Z"
                                            fill="#FFB1B5"
                                          />
                                          <path
                                            d="M56.7065 22.9221C48.0801 17.5894 36.9624 16.1815 24.9011 18.8393C25.3868 19.6215 25.7811 20.5676 25.8391 21.6219C28.6766 21.1475 32.6634 20.7437 37.1293 21.0695C42.5028 21.4609 46.5804 23.3422 49.5577 24.7158C51.4991 25.6113 53.0323 26.3189 54.2514 26.3525C55.4034 26.3846 56.1088 26.1656 56.6875 25.5971C57.0795 25.2121 57.3206 24.5008 57.2608 23.9052C57.2306 23.6038 57.1085 23.1914 56.7071 22.9224L56.7065 22.9221Z"
                                            fill="#9DD9AF"
                                          />
                                          <path
                                            d="M41.582 7.17397C34.4785 7.42136 28.6228 8.86929 24.9187 10.06C25.7456 11.0822 26.1027 12.4641 26.0762 13.3121C29.4924 12.3923 34.8118 11.3416 41.3888 11.3C48.065 11.2587 53.255 12.5693 56.4341 13.6767C59.2258 14.6493 61.5648 15.8551 62.9561 17.0053C64.7063 17.7716 66.2973 17.398 66.8326 16.5831C67.249 15.9498 67.2813 14.7462 66.3693 13.6002C64.0251 10.6547 54.7845 6.71313 41.5817 7.17367L41.582 7.17397Z"
                                            fill="#9DDEF7"
                                          />
                                          <path
                                            d="M24.0272 9.24751C24.0831 9.28298 24.135 9.32309 24.1884 9.36164C27.9245 8.12439 34.0574 6.54259 41.5516 6.28163C49.2488 6.01357 54.9562 7.21535 58.3886 8.27061C59.6557 8.6602 60.8443 9.10315 61.9218 9.58127C61.9315 9.58466 61.9413 9.58621 61.9508 9.59022C61.9679 9.59762 63.7169 10.3247 64.8542 9.88264C65.7717 9.52605 66.1411 9.01308 66.2168 7.9899C66.2681 7.29524 65.86 6.50619 65.0361 5.70819C60.4111 1.22898 49.1347 0.27953 40.6145 1.29253C31.7351 2.3484 25.2051 5.02093 21.2904 7.07685C20.5875 7.44608 19.9428 7.80884 19.354 8.15771C19.466 8.47388 19.5384 8.77063 19.5829 9.01801C21.3085 8.21261 23.0172 8.60405 24.0269 9.24751H24.0272Z"
                                            fill="#A1FCE7"
                                          />
                                          <path
                                            d="M56.1466 14.5204C53.0326 13.4355 47.9458 12.1499 41.3947 12.1924C34.6556 12.235 29.274 13.3458 25.9453 14.2699C25.5604 15.8295 24.4323 16.6963 23.4778 17.0955C23.733 17.3413 24.0388 17.6634 24.3447 18.0492C36.7633 15.2336 48.2394 16.6491 57.1478 22.1481C57.1536 22.1515 57.1597 22.1534 57.1652 22.1571C57.1722 22.1617 57.1783 22.1669 57.1851 22.1716C57.4918 22.3613 57.7955 22.5559 58.0959 22.7552C58.1988 22.8237 58.2851 22.881 58.355 22.9258C59.8916 23.915 61.6675 23.6837 62.7212 23.1849C63.2642 22.9279 63.7196 22.3233 63.9101 21.6071C64.1662 20.6437 63.9302 19.5654 63.2456 18.5709C62.5869 17.6137 60.3324 15.9788 56.146 14.5204H56.1466Z"
                                            fill="#FFE66A"
                                          />
                                          <path
                                            d="M23.993 19.0457C23.7961 18.7585 23.5886 18.4994 23.3883 18.2736C22.8267 17.6406 22.3276 17.2662 22.3206 17.2609C22.1771 17.1548 22.1106 16.9722 22.1518 16.7973C22.193 16.623 22.3328 16.4907 22.5074 16.4608C22.5926 16.446 24.2463 16.1363 24.9185 14.5674C25.0424 14.2778 25.1334 13.9455 25.1746 13.564C25.1834 13.4829 25.1898 13.3993 25.1941 13.3135C25.232 12.5214 24.8345 11.1848 24.0025 10.3634C23.8651 10.2279 23.7174 10.1049 23.5565 10.0025C23.4103 9.90929 23.2455 9.82292 23.0657 9.74766C22.1271 9.35406 20.7739 9.26245 19.4544 10.103C19.3189 10.1891 19.1482 10.1946 19.0075 10.1172C18.8671 10.0398 18.7789 9.89171 18.7774 9.73008C18.7768 9.68874 18.7645 9.21741 18.5817 8.62701C18.5008 8.36543 18.3864 8.08103 18.224 7.79971C17.9444 7.3148 17.5238 6.84069 16.8901 6.51526C15.881 5.99704 13.7241 5.75181 12.2312 7.30092C11.2724 8.29572 11.1595 9.57831 11.1586 9.59096C11.1442 9.76925 11.0261 9.92163 10.8579 9.97839C10.6901 10.0348 10.5048 9.98456 10.3876 9.85069C10.3543 9.81367 9.5219 8.90031 8.04882 8.90031C5.73541 8.90031 4.54711 10.4408 4.20952 11.3511C3.49495 13.2793 4.44363 14.82 4.4531 14.8355C4.53734 14.9693 4.54497 15.1384 4.47324 15.2793C4.40121 15.4203 4.2608 15.5122 4.1039 15.5206C4.03217 15.5249 2.30238 15.6464 1.40254 17.231C0.603419 18.6379 0.692549 20.8231 2.22943 21.9005C3.37011 22.7001 5.12585 22.4354 5.8282 22.2846C5.85873 22.2781 5.88955 22.2747 5.92008 22.2747C6.02966 22.2747 6.13649 22.316 6.21891 22.3922C6.32421 22.49 6.37611 22.6331 6.3581 22.7766C6.32971 23.0079 5.70946 28.4576 9.85156 29.043C12.3802 29.4005 13.7183 28.1716 14.7931 27.1839C15.211 26.8002 15.6056 26.4374 16.022 26.2116C16.5448 25.9282 17.4099 25.9201 18.5048 25.9103C20.7642 25.8893 23.576 25.8631 24.5974 23.5604C24.724 23.2751 24.8165 22.9873 24.8782 22.6979C24.9432 22.3922 24.9716 22.0847 24.9646 21.7753C24.945 20.9141 24.6483 20.0396 24.0711 19.1598C24.0455 19.1207 24.0189 19.0833 23.993 19.0454V19.0457ZM19.7285 12.0966C19.8698 11.9307 20.0353 11.794 20.2166 11.686C20.4711 11.5343 20.7575 11.4408 21.0609 11.4183C21.1149 11.4143 21.1686 11.4137 21.2223 11.4143C21.6832 11.4177 22.1243 11.583 22.4775 11.8909C22.8718 12.2345 23.1102 12.7126 23.1487 13.2373C23.1762 13.6109 23.0959 13.9671 22.9378 14.2784C22.6811 14.7836 22.2147 15.1658 21.6454 15.2994C21.5489 15.3219 21.4503 15.3398 21.3487 15.3475C21.2996 15.3512 21.2504 15.3531 21.2016 15.3531C20.7349 15.3531 20.2889 15.1862 19.9318 14.8753C19.5374 14.5316 19.299 14.0535 19.2606 13.5288C19.2221 13.0041 19.3882 12.4958 19.7279 12.0972L19.7285 12.0966ZM14.8914 8.66402C15.4029 8.62547 15.9014 8.76489 16.3168 9.05793C16.3791 9.10204 16.4398 9.14893 16.4981 9.19983C16.6709 9.35036 16.8168 9.52433 16.934 9.71496C17.1199 10.0173 17.2329 10.3621 17.2594 10.727C17.3031 11.3221 17.1147 11.8989 16.7292 12.3508C16.3437 12.8027 15.8071 13.076 15.218 13.1201C15.1621 13.1244 15.1066 13.1263 15.051 13.1263C14.522 13.1263 14.0159 12.9369 13.6112 12.5843C13.164 12.1947 12.8936 11.6524 12.8499 11.0571C12.7599 9.82848 13.6753 8.75502 14.8911 8.66402H14.8914ZM6.1136 20.3502C5.77356 20.7487 5.30044 20.9896 4.78123 21.0285C4.73209 21.0322 4.68294 21.0341 4.6341 21.0341C4.1677 21.0341 3.72144 20.8672 3.36461 20.5562C2.97024 20.2126 2.73185 19.7345 2.69339 19.2098C2.65493 18.6851 2.82098 18.1768 3.16102 17.7779C3.50106 17.3794 3.97418 17.1385 4.49339 17.0996C5.56386 17.0197 6.50186 17.8353 6.58123 18.9183C6.61969 19.443 6.45364 19.9514 6.1139 20.3502H6.1136ZM8.24234 15.6973C7.71336 15.6973 7.20727 15.5079 6.80253 15.1553C6.35535 14.7658 6.08491 14.2235 6.04126 13.6281C5.95121 12.3995 6.86693 11.3261 8.08239 11.2351C8.6709 11.191 9.242 11.3813 9.68917 11.7709C10.1363 12.1605 10.4068 12.7031 10.4504 13.2981C10.4941 13.8931 10.3058 14.4699 9.92024 14.9218C9.53472 15.3737 8.99811 15.647 8.409 15.6911C8.35314 15.6955 8.29759 15.6973 8.24203 15.6973H8.24234ZM19.7059 21.2568C19.2682 21.9277 18.3998 22.313 17.1248 22.4024C15.3117 22.5295 14.5135 23.0662 13.7418 23.5851C13.19 23.9561 12.6195 24.3396 11.7428 24.516C11.5926 24.5462 11.4449 24.561 11.3011 24.561C10.3741 24.561 9.60035 23.9484 9.26458 22.9083C8.78902 21.4348 9.24658 18.6962 12.4568 17.1928C13.7678 16.5786 15.7787 16.1671 17.4911 16.8525C18.5762 17.2868 19.3882 18.1154 19.8396 19.2487C19.8396 19.2493 19.8399 19.2496 19.8402 19.2499C19.8423 19.2555 19.8445 19.261 19.8463 19.2666C19.9455 19.5537 19.9989 19.8347 20.0078 20.1025C20.0221 20.5322 19.9211 20.927 19.7062 21.2565L19.7059 21.2568Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M5.54075 18.3792C5.20835 17.9652 4.7337 17.934 4.68059 17.9319C4.47363 17.9245 4.29232 18.087 4.28378 18.2983C4.27523 18.5093 4.43456 18.6873 4.64335 18.6959C4.65098 18.6966 4.83351 18.7126 4.95317 18.8616C5.11647 19.0652 5.08839 19.2891 5.08808 19.2919C5.05206 19.4998 5.18973 19.6982 5.39546 19.7345C5.41743 19.7386 5.43972 19.7404 5.46139 19.7404C5.53343 19.7404 5.60149 19.7188 5.6601 19.6821C5.74831 19.6266 5.81425 19.5356 5.83378 19.4239C5.83897 19.3937 5.86186 19.2364 5.82798 19.0257C5.79746 18.836 5.72054 18.6028 5.54106 18.3792H5.54075Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M8.4474 12.0783C8.23954 12.0564 8.04907 12.2087 8.0277 12.4191C8.00633 12.6292 8.15315 12.8164 8.36102 12.8383C8.36926 12.8396 8.56645 12.8726 8.74074 13.094C8.85154 13.2347 8.87993 13.4667 8.88145 13.5416C8.88298 13.752 9.05208 13.9213 9.25995 13.9213H9.2627C9.47179 13.9198 9.63997 13.7474 9.63845 13.5361C9.63814 13.4812 9.62593 12.9898 9.3329 12.6178C8.9599 12.1446 8.49868 12.0838 8.4474 12.0786V12.0783Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M15.2121 10.3408C15.2146 10.3411 15.4679 10.388 15.5745 10.6181C15.5876 10.6462 15.5974 10.6736 15.6059 10.7008C15.6709 10.9087 15.6129 11.0774 15.612 11.0799C15.5336 11.2758 15.6273 11.4985 15.8211 11.5777C15.8675 11.5969 15.9157 11.6058 15.9627 11.6058C16.1123 11.6058 16.2542 11.5154 16.3138 11.3668C16.3348 11.3143 16.5119 10.8377 16.26 10.2942C16.249 10.2702 16.2347 10.2504 16.2225 10.2279C16.0448 9.90093 15.7555 9.71986 15.5232 9.6372C15.4475 9.61036 15.3776 9.59247 15.3205 9.58414C15.1145 9.5536 14.9216 9.69858 14.8916 9.90772C14.8816 9.97897 14.8926 10.0478 14.9182 10.1095C14.968 10.2291 15.0754 10.3211 15.2118 10.3411L15.2121 10.3408Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M21.3127 12.9757C21.4345 13.0448 21.5151 13.1395 21.5524 13.2576C21.6094 13.4387 21.5753 13.5948 21.5496 13.6719C21.4828 13.8721 21.5893 14.0889 21.7874 14.1565C21.8274 14.17 21.8683 14.1765 21.9083 14.1765C22.0664 14.1765 22.2135 14.0757 22.2669 13.9162C22.3344 13.7138 22.3902 13.3949 22.2733 13.025C22.1518 12.641 21.8857 12.4235 21.6836 12.3088C21.5014 12.2054 21.2706 12.2708 21.1684 12.455C21.0661 12.6391 21.1308 12.8723 21.3131 12.9757H21.3127Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M18.4702 20.0877C18.421 19.8822 18.2162 19.7561 18.0135 19.8057C17.8106 19.8554 17.6854 20.0621 17.7346 20.2672C17.7532 20.3449 17.7687 20.4267 17.7806 20.51C17.8078 20.7003 17.9696 20.8375 18.1546 20.8375C18.1726 20.8375 18.1909 20.8363 18.2095 20.8335C18.4165 20.8033 18.5596 20.6093 18.5297 20.4001C18.5144 20.2937 18.4946 20.1885 18.4702 20.0877Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M17.7456 18.7451C16.8256 17.8003 15.4804 17.7627 15.4236 17.7617C15.2106 17.7593 15.043 17.9246 15.0384 18.1356C15.0336 18.3463 15.199 18.5212 15.4078 18.5264C15.4188 18.5267 16.5066 18.5628 17.2062 19.2816C17.2804 19.3577 17.3781 19.3957 17.4761 19.3957C17.5741 19.3957 17.6678 19.3593 17.7413 19.2859C17.8903 19.1378 17.8921 18.8957 17.7456 18.7451Z"
                                            fill="white"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_5_2746">
                                            <rect width="68" height="30" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      HypurrFi points
                                    </Tag>
                                  )}
                                  {isKEIPoints && (
                                    <Tag variant={3} style={{ background: 'rgb(178, 242, 253)', minWidth: 'unset' }}>
                                      <img
                                        src={KeikoLogo}
                                        style={{ width: '14px', borderRadius: '100px', marginRight: '2px' }}
                                        alt="kei logo"
                                      />
                                      KEIKO points
                                    </Tag>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div style={{ display: 'flex', gap: '32px' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '20px' }}>
                                <span style={{ color: '#c3c5cb', fontWeight: 400, fontSize: '14px' }}>APR</span>
                                <span style={{ fontWeight: 500 }} className="responsive-text">
                                  {pool.apr ? `${roundToDecimalPlace(`${pool.apr}`, '2')}%` : 'N/A'}
                                </span>
                              </div>

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '20px' }}>
                                <span style={{ color: '#c3c5cb', fontWeight: 400, fontSize: '14px' }}>1D Volume</span>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    gap: '2px',
                                  }}
                                >
                                  {volumeIncreasingIcon && volumeIncreasingIcon}{' '}
                                  <span style={{ fontWeight: 500 }} className="responsive-text">
                                    {pool.h24 ? `$${roundToDecimalPlace(`${pool.h24}`, '2')}` : 'N/A'}
                                  </span>
                                </div>
                              </div>

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '20px' }}>
                                <span style={{ color: '#c3c5cb', fontWeight: 400, fontSize: '14px' }}>TVL</span>
                                <span style={{ fontWeight: 500 }} className="responsive-text">
                                  {pool.totalTvlUSD ? `$${roundToDecimalPlace(`${pool.totalTvlUSD}`, '2')}` : 'N/A'}
                                </span>
                              </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '20px' }}>
                              <span style={{ color: '#c3c5cb', fontWeight: 400, fontSize: '14px' }}>Reserve</span>
                              <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <TokenLogo token={pool.token0.token0Address} />
                                  <span style={{ fontSize: '16px', fontWeight: 500 }}>
                                    {roundToDecimalPlace(
                                      `${formatUnits(pool.reserves.reserve0, pool.token0.token0Decimal)}`,
                                      '2'
                                    )}{' '}
                                  </span>
                                </div>
                                <span style={{ padding: '0 8px' }}>/</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <TokenLogo token={pool.token1.token1Address} />
                                  <span style={{ fontSize: '16px', fontWeight: 500 }}>
                                    {roundToDecimalPlace(
                                      `${formatUnits(pool.reserves.reserve1, pool.token1.token1Decimal)}`,
                                      '2'
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '28px' }}>
                              <TagButton
                                onClick={() => {
                                  history.push(addV2LPRoute)
                                }}
                                style={{ width: '100%', fontSize: '14px', padding: '10px', height: 'unset' }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-plus"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M12 5l0 14" />
                                  <path d="M5 12l14 0" />
                                </svg>
                                Add Liq.
                              </TagButton>
                              <TagButton
                                onClick={() => {
                                  history.push(swapRoute)
                                }}
                                style={{ width: '100%', fontSize: '14px', padding: '10px', height: 'unset' }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-repeat"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
                                  <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
                                </svg>
                                Swap
                              </TagButton>
                            </div>
                          </LeverageItem>
                        )
                      })}
                    </GridContainerForCard>
                  ) : (
                    <>
                      <TableWrapper>
                        <thead>
                          <tr>
                            <th colSpan={1} style={{ textAlign: 'center' }}>
                              #
                            </th>
                            <th style={{ textAlign: 'left' }}>Pool</th>
                            <th style={{ textAlign: 'left' }}>Reserve</th>
                            <th style={{ textAlign: 'center' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  gap: '2px',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                  alignItems: 'center',
                                  ...(sortBy === 'apr' ? { color: '#4AFB39' } : {}),
                                }}
                                onClick={() => {
                                  if (!isLeverage) {
                                    setSortBy('apr')
                                  }
                                }}
                              >
                                {sortBy === 'apr' && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4AFB39"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 9l4 -4l4 4m-4 -4v14" />
                                    <path d="M21 15l-4 4l-4 -4m4 4v-14" />
                                  </svg>
                                )}
                                APR <QuestionHelper text="Annualized based on 1 day fees" />
                              </div>
                            </th>
                            <th
                              style={{
                                textAlign: 'center',
                                cursor: 'pointer',
                                alignItems: 'center',
                                gap: '2px',
                                justifyContent: 'center',
                                ...(sortBy === 'volume' ? { color: '#4AFB39' } : {}),
                              }}
                              onClick={() => {
                                if (!isLeverage) {
                                  setSortBy('volume')
                                }
                              }}
                            >
                              <div
                                style={{ display: 'flex', alignItems: 'center', gap: '2px', justifyContent: 'center' }}
                              >
                                {sortBy === 'volume' && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4AFB39"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 9l4 -4l4 4m-4 -4v14" />
                                    <path d="M21 15l-4 4l-4 -4m4 4v-14" />
                                  </svg>
                                )}
                                1D volume
                              </div>
                            </th>
                            <th
                              style={{
                                textAlign: 'center',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                                justifyContent: 'center',
                                ...(sortBy === 'tvl' ? { color: '#4AFB39' } : {}),
                              }}
                              onClick={() => {
                                if (!isLeverage) {
                                  setSortBy('tvl')
                                }
                              }}
                            >
                              {sortBy === 'tvl' && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#4AFB39"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"
                                >
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M3 9l4 -4l4 4m-4 -4v14" />
                                  <path d="M21 15l-4 4l-4 -4m4 4v-14" />
                                </svg>
                              )}
                              TVL
                            </th>
                            <th style={{ textAlign: 'center' }}>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {data.map((pool: any, index: number) => {
                            const isHypurrFiPoints =
                              ((pool.token0.token0Symbol === 'WHYPE' || pool.token1.token1Symbol === 'WHYPE') &&
                                (pool.token0.token0Symbol === 'USDXL' || pool.token1.token1Symbol === 'USDXL')) ||
                              ((pool.token0.token0Symbol === 'KEI' || pool.token1.token1Symbol === 'KEI') &&
                                (pool.token0.token0Symbol === 'USDXL' || pool.token1.token1Symbol === 'USDXL'))
                            const isKEIPoints = pool.token0.token0Symbol === 'KEI' || pool.token1.token1Symbol === 'KEI'
                            const isVolumeIncreasing =
                              pool.prevH24 && pool.h24 ? parseFloat(pool.h24) - parseFloat(pool.prevH24) > 0 : null

                            const volumeIncreasingIcon =
                              isVolumeIncreasing !== null ? (
                                isVolumeIncreasing ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4AFB39"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-trending-up"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 17l6 -6l4 4l8 -8" />
                                    <path d="M14 7l7 0l0 7" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="red"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-trending-down"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 7l6 6l4 -4l8 8" />
                                    <path d="M21 10l0 7l-7 0" />
                                  </svg>
                                )
                              ) : (
                                <></>
                              )

                            const addV2LPRoute = `/add${pool.version === 'v3' ? '/' : '/v2/'}${
                              pool.token0.token0Address === WETH9[CURRENT_CHAIN].address
                                ? 'HYPE'
                                : pool.token0.token0Address
                            }/${
                              pool.token1.token1Address === WETH9[CURRENT_CHAIN].address
                                ? 'HYPE'
                                : pool.token1.token1Address
                            }`

                            const swapRoute = `/swap${pool.version === 'v3' ? '/' : '/v2/'}?inputCurrency=${
                              pool.token0.token0Address === WETH9[CURRENT_CHAIN].address
                                ? 'HYPE'
                                : pool.token0.token0Address
                            }&outputCurrency=${
                              pool.token1.token1Address === WETH9[CURRENT_CHAIN].address
                                ? 'HYPE'
                                : pool.token1.token1Address
                            }`

                            return (
                              <tr key={pool.pairAddress}>
                                <td style={{ color: '#c3c5cb', fontSize: 14, fontWeight: 400, textAlign: 'center' }}>
                                  {index + 1 + TOTAL_PER_PAGE * currentPage}
                                </td>
                                <td style={{ minWidth: '200px' }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: '8px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        gap: '8px',
                                        paddingLeft: '12px',
                                      }}
                                    >
                                      <PoolLogo tokenA={pool.token0.token0Address} tokenB={pool.token1.token1Address} />
                                      <span style={{ fontWeight: 500, fontSize: 14 }}>
                                        {pool.token0.token0Symbol === 'WHYPE' ? 'HYPE' : pool.token0.token0Symbol} /{' '}
                                        {pool.token1.token1Symbol === 'WHYPE' ? 'HYPE' : pool.token1.token1Symbol}
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        gap: '8px',
                                        flexWrap: 'wrap',
                                      }}
                                    >
                                      <Tag variant={pool.version === 'v3' ? 2 : 1}>
                                        <div style={{ padding: '0 2px' }}>{pool.version === 'v3' ? 'v3' : 'v2'}</div>
                                      </Tag>

                                      <Tag variant={1}>
                                        <div style={{ padding: '0 2px' }}>
                                          {pool.fee ? formattedFeeAmount(pool.fee) : '0.3'}%
                                        </div>
                                      </Tag>
                                      <Tag variant={1}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 1695.06 1200.04"
                                          fill="#4AFC38"
                                        >
                                          <path
                                            className="cls-1"
                                            d="m624.44,12.53C390.27-54.51,125.14,154.18,32.26,478.64c-92.88,324.46,21.66,641.83,255.83,708.87,234.17,67.04,499.3-141.65,592.18-466.11,92.88-324.46-21.66-641.83-255.83-708.87Zm-39.45,304.79c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
                                          />
                                          <path
                                            className="cls-1"
                                            d="m1470.12,266.02c-182.84-52.34-389.86,110.6-462.38,363.94-72.52,253.34,16.91,501.15,199.75,553.49,182.84,52.34,389.86-110.6,462.38-363.94,72.52-253.34-16.91-501.15-199.75-553.49Zm-26.94,293.29c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
                                          />
                                        </svg>
                                        Points
                                      </Tag>
                                      {isHypurrFiPoints && (
                                        <Tag variant={3}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="68"
                                            height="30"
                                            viewBox="0 0 68 30"
                                            fill="none"
                                            style={{ width: '20px' }}
                                          >
                                            <g clipPath="url(#clip0_5_2746)">
                                              <path
                                                d="M67.0578 13.0404C66.4812 12.3161 65.5848 11.5853 64.445 10.8891C64.6941 10.8604 64.9395 10.8055 65.1715 10.7155C66.4196 10.2306 66.9956 9.43534 67.0975 8.05619C67.1693 7.087 66.6677 6.05241 65.6473 5.06378C64.593 4.04277 62.0101 2.15034 56.5546 0.947326C51.8346 -0.0937408 46.2872 -0.28067 40.5115 0.405971C31.4797 1.48004 24.8332 4.20594 20.8477 6.30381C20.1734 6.65854 19.5519 7.0068 18.982 7.3421C18.631 6.7335 18.0987 6.13446 17.2904 5.71927C15.7444 4.92528 13.224 4.99129 11.5989 6.67798C10.9329 7.36924 10.5995 8.1657 10.4347 8.73944C9.92833 8.3952 9.11975 8.00746 8.04927 8.00746C5.60186 8.00746 3.94228 9.52942 3.38308 11.0375C2.79397 12.6273 3.13278 13.9947 3.42612 14.7326C2.67065 14.9158 1.41398 15.4186 0.637146 16.7864C-0.655543 19.0622 0.175929 21.5463 1.72685 22.6333C2.87089 23.4353 4.38213 23.4149 5.43948 23.2604C5.41597 23.8776 5.43307 24.8983 5.69008 25.9629C6.245 28.2606 7.64178 29.6314 9.72962 29.9266C10.084 29.9766 10.4182 29.9997 10.7345 29.9997C13.0412 29.9997 14.3784 28.7711 15.3875 27.8439C15.7801 27.483 16.1192 27.1714 16.4397 26.9978C16.7709 26.8182 17.6173 26.8105 18.5132 26.8022C20.7582 26.7812 24.1507 26.7497 25.4034 23.9248C25.6152 23.447 25.7428 22.9806 25.8038 22.5293C28.591 22.0518 32.5774 21.6311 37.0656 21.9578C42.2803 22.3378 46.112 24.1056 49.1907 25.5258C51.2229 26.4635 52.8285 27.2041 54.2268 27.2427C54.3019 27.2448 54.3758 27.2458 54.4484 27.2458C55.7084 27.2458 56.5948 26.9302 57.3024 26.2349C57.8857 25.6621 58.2206 24.6991 58.14 23.8326C58.9949 24.3147 59.8975 24.5017 60.7379 24.5017C61.6426 24.5017 62.4747 24.286 63.0958 23.9921C63.8797 23.621 64.503 22.8156 64.763 21.8375C65.0707 20.6807 64.8339 19.4163 64.0982 18.2543C64.3504 18.2913 64.5994 18.3114 64.8415 18.3114C66.0154 18.3114 67.0374 17.8832 67.5682 17.0754C68.1762 16.15 68.2541 14.5432 67.0572 13.0394L67.0578 13.0404ZM21.2906 7.07651C25.2053 5.0206 31.7352 2.34806 40.6146 1.29219C49.1345 0.278884 60.4113 1.22865 65.0362 5.70786C65.8601 6.50585 66.2682 7.2946 66.2169 7.98957C66.1412 9.01274 65.7719 9.52603 64.8543 9.8823C63.717 10.3243 61.968 9.59728 61.9509 9.58988C61.9414 9.58587 61.9313 9.58433 61.9219 9.58093C60.8444 9.10281 59.6561 8.65986 58.3887 8.27027C54.9563 7.21501 49.249 6.01324 41.5517 6.28129C34.0572 6.54256 27.9243 8.12406 24.1885 9.36131C24.1351 9.32275 24.0832 9.28265 24.0273 9.24717C23.0176 8.60372 21.3089 8.21228 19.5834 9.01768C19.5385 8.76998 19.4661 8.47355 19.3544 8.15737C19.9432 7.8085 20.5879 7.44574 21.2909 7.07651H21.2906ZM24.8783 22.6978C24.8167 22.9871 24.7242 23.2749 24.5975 23.5602C23.5762 25.8632 20.7643 25.8891 18.5049 25.9101C17.4097 25.9203 16.545 25.9283 16.0221 26.2115C15.6058 26.4373 15.2111 26.7997 14.7932 27.1838C13.7182 28.1715 12.3803 29.4004 9.85171 29.0429C5.70992 28.4571 6.32986 23.0075 6.35825 22.7764C6.37626 22.633 6.32406 22.4899 6.21906 22.3921C6.13664 22.3156 6.02981 22.2745 5.92023 22.2745C5.8897 22.2745 5.85888 22.2776 5.82835 22.2844C5.1263 22.4353 3.37026 22.6999 2.22958 21.9004C0.692394 20.8229 0.60357 18.6378 1.40269 17.2308C2.30284 15.6463 4.03232 15.5247 4.10405 15.5204C4.26095 15.5121 4.40136 15.4202 4.47339 15.2792C4.54543 15.1382 4.5378 14.9692 4.45325 14.8353C4.44348 14.8199 3.4948 13.2791 4.20967 11.3509C4.54696 10.4406 5.73525 8.90015 8.04897 8.90015C9.52175 8.90015 10.3544 9.81321 10.3877 9.85053C10.5049 9.98471 10.6902 10.0347 10.8581 9.97824C11.026 9.92179 11.1444 9.7694 11.1587 9.5908C11.1597 9.57785 11.2726 8.29556 12.2314 7.30077C13.7243 5.75166 15.8811 5.99689 16.8902 6.51511C17.5239 6.84054 17.9445 7.31465 18.2241 7.79955C18.3865 8.08087 18.5007 8.36528 18.5819 8.62685C18.7647 9.21694 18.7769 9.68859 18.7775 9.72992C18.779 9.89156 18.8673 10.0396 19.0077 10.117C19.1481 10.1945 19.319 10.1889 19.4545 10.1029C20.7741 9.2626 22.1272 9.3539 23.0658 9.7475C23.2456 9.82277 23.4104 9.90914 23.5567 10.0023C23.7175 10.1047 23.8656 10.2278 24.0026 10.3632C24.8347 11.1846 25.2321 12.5212 25.1943 13.3134C25.1903 13.3991 25.1836 13.4824 25.1747 13.5638C25.1338 13.9454 25.0429 14.2776 24.9186 14.5673C24.2468 16.1361 22.593 16.4458 22.5075 16.4606C22.3329 16.4905 22.1928 16.6232 22.1519 16.7971C22.1107 16.9717 22.1773 17.1547 22.3207 17.2608C22.3278 17.266 22.8268 17.6402 23.3885 18.2735C23.5887 18.4993 23.7963 18.7584 23.9931 19.0455C24.0191 19.0835 24.0456 19.1208 24.0713 19.16C24.6488 20.0394 24.9452 20.9139 24.9647 21.7755C24.9717 22.0848 24.9434 22.3924 24.8783 22.6981V22.6978ZM56.6873 25.5955C56.1086 26.164 55.4032 26.383 54.2512 26.3509C53.0321 26.317 51.4989 25.6097 49.5576 24.7142C46.5802 23.3406 42.5026 21.4593 37.1291 21.0678C32.6635 20.7421 28.6767 21.1459 25.8389 21.6203C25.7809 20.566 25.3866 19.6199 24.9009 18.8376C36.9625 16.1799 48.0799 17.5877 56.7063 22.9205C57.1076 23.1895 57.2297 23.6022 57.26 23.9032C57.3198 24.4986 57.0787 25.2102 56.6867 25.5952L56.6873 25.5955ZM63.9108 21.6067C63.7204 22.3233 63.2646 22.9279 62.7219 23.1845C61.6682 23.6833 59.8923 23.9147 58.3558 22.9254C58.2859 22.8804 58.1995 22.823 58.0966 22.7548C57.7963 22.5552 57.4922 22.3609 57.1858 22.1712C57.1788 22.1666 57.173 22.161 57.1659 22.1567C57.1605 22.153 57.154 22.1512 57.1485 22.1478C48.2401 16.6488 36.7644 15.2332 24.3454 18.0489C24.0395 17.663 23.7337 17.341 23.4785 17.0951C24.433 16.696 25.5612 15.8292 25.9461 14.2696C29.2747 13.3454 34.6564 12.2347 41.3955 12.1921C47.9465 12.1495 53.0333 13.4352 56.1474 14.5201C60.3337 15.9785 62.5885 17.6137 63.2469 18.5705C63.9316 19.5653 64.1675 20.6434 63.9114 21.6067H63.9108ZM66.8332 16.5825C66.2975 17.3974 64.7069 17.771 62.9566 17.0047C61.5651 15.8548 59.226 14.6487 56.4346 13.6761C53.2555 12.5684 48.0655 11.2581 41.3893 11.2994C34.8124 11.341 29.4929 12.3914 26.0767 13.3115C26.1033 12.4635 25.7464 11.0816 24.9192 10.0594C28.6233 8.86869 34.4787 7.42076 41.5826 7.17337C54.7851 6.71283 64.0259 10.6544 66.3701 13.5999C67.2822 14.7459 67.2498 15.9495 66.8335 16.5828L66.8332 16.5825Z"
                                                fill="#231F20"
                                              />
                                              <path
                                                d="M9.92078 14.9215C10.3063 14.4696 10.4946 13.8927 10.451 13.2977C10.4073 12.7027 10.1369 12.1601 9.68971 11.7705C9.24223 11.3809 8.67143 11.1909 8.08293 11.2347C6.86716 11.3257 5.95144 12.3995 6.0418 13.6278C6.08544 14.2228 6.35589 14.7651 6.80306 15.155C7.20811 15.5075 7.7139 15.6969 8.24288 15.6969C8.29843 15.6969 8.35398 15.6948 8.40984 15.6908C8.99865 15.6467 9.53556 15.3734 9.92108 14.9215H9.92078ZM9.26299 13.9214H9.26024C9.05268 13.9214 8.88327 13.7521 8.88174 13.5417C8.88022 13.4667 8.85183 13.2348 8.74103 13.0941C8.56643 12.8726 8.36955 12.8396 8.36131 12.8384C8.15344 12.8168 8.00662 12.6293 8.02799 12.4192C8.04935 12.2091 8.23982 12.0568 8.44769 12.0783C8.49897 12.0836 8.96019 12.1444 9.33319 12.6175C9.62622 12.9896 9.63843 13.4809 9.63874 13.5358C9.64026 13.7471 9.47207 13.9196 9.26299 13.9211V13.9214Z"
                                                fill="#FFB1B5"
                                              />
                                              <path
                                                d="M13.6116 12.5848C14.0166 12.9373 14.5224 13.1267 15.0514 13.1267C15.107 13.1267 15.1625 13.1246 15.2184 13.1206C15.8072 13.0765 16.3441 12.8032 16.7296 12.3513C17.1151 11.8994 17.3035 11.3225 17.2598 10.7275C17.233 10.3626 17.1203 10.0177 16.9344 9.71544C16.8172 9.52481 16.6716 9.35114 16.4985 9.2003C16.4402 9.14941 16.3795 9.10252 16.3172 9.05841C15.9018 8.76537 15.4033 8.62594 14.8918 8.6645C13.676 8.7555 12.7603 9.82926 12.8506 11.0576C12.8943 11.6526 13.1647 12.1949 13.6119 12.5848H13.6116ZM14.8921 9.90915C14.922 9.70001 15.1146 9.55473 15.3209 9.58557C15.3777 9.5939 15.4479 9.61149 15.5236 9.63863C15.7559 9.7213 16.0453 9.90237 16.2229 10.2293C16.2351 10.2519 16.2492 10.2719 16.2605 10.2957C16.512 10.8392 16.3349 11.3154 16.3142 11.3682C16.2547 11.5169 16.113 11.6072 15.9632 11.6072C15.9158 11.6072 15.8679 11.5983 15.8215 11.5792C15.6277 11.4999 15.5343 11.2772 15.6124 11.0813C15.6134 11.0788 15.6714 10.9101 15.6063 10.7022C15.5978 10.6751 15.588 10.6476 15.5749 10.6195C15.4684 10.3891 15.215 10.3425 15.2126 10.3422C15.0761 10.3222 14.9687 10.2306 14.9189 10.1106C14.8933 10.0489 14.882 9.9801 14.8924 9.90885L14.8921 9.90915Z"
                                                fill="#FFB1B5"
                                              />
                                              <path
                                                d="M4.49319 17.0992C3.97398 17.138 3.50086 17.3789 3.16082 17.7775C2.82078 18.176 2.65473 18.6847 2.69319 19.2094C2.73165 19.7341 2.97005 20.2122 3.36442 20.5558C3.72155 20.8667 4.1675 21.0336 4.63391 21.0336C4.68274 21.0336 4.73189 21.0318 4.78103 21.0281C5.30024 20.9892 5.77336 20.7483 6.1134 20.3498C6.45344 19.9512 6.61949 19.4426 6.58072 18.9179C6.50136 17.8345 5.56336 17.0193 4.49289 17.0992H4.49319ZM5.8335 19.4237C5.81396 19.5354 5.74803 19.6264 5.65982 19.6819C5.60121 19.7186 5.53314 19.7402 5.4611 19.7402C5.43943 19.7402 5.41746 19.7384 5.39517 19.7344C5.18944 19.698 5.05178 19.4996 5.0878 19.2917C5.0878 19.2889 5.11618 19.0647 4.95288 18.8614C4.83323 18.7124 4.651 18.6964 4.64306 18.6958C4.43428 18.6871 4.27494 18.5091 4.28349 18.2982C4.29204 18.0872 4.47335 17.9246 4.6803 17.9317C4.73341 17.9339 5.20776 17.965 5.54047 18.379C5.71995 18.6026 5.79687 18.8355 5.82739 19.0255C5.86127 19.2362 5.83838 19.3935 5.83319 19.4237H5.8335Z"
                                                fill="#FFB1B5"
                                              />
                                              <path
                                                d="M22.9382 14.2782C23.0964 13.967 23.1763 13.6107 23.1492 13.2372C23.1107 12.7125 22.8723 12.2344 22.4779 11.8907C22.1248 11.5829 21.6834 11.4175 21.2228 11.4142C21.1691 11.4138 21.1154 11.4142 21.0613 11.4182C20.7582 11.441 20.4716 11.5345 20.217 11.6859C20.0357 11.7939 19.8703 11.9305 19.729 12.0965C19.3889 12.495 19.2229 13.0034 19.2616 13.5281C19.3001 14.0528 19.5385 14.5309 19.9329 14.8745C20.29 15.1854 20.7359 15.3523 21.2026 15.3523C21.2515 15.3523 21.3006 15.3505 21.3498 15.3468C21.4514 15.3391 21.55 15.3215 21.6465 15.2986C22.2154 15.1651 22.6821 14.7829 22.9389 14.2776L22.9382 14.2782ZM22.267 13.9161C22.2139 14.0759 22.0665 14.1764 21.9084 14.1764C21.8684 14.1764 21.8275 14.17 21.7875 14.1564C21.5894 14.0888 21.4829 13.872 21.5497 13.6718C21.5753 13.595 21.6098 13.4386 21.5525 13.2575C21.5152 13.1394 21.4346 13.0444 21.3128 12.9756C21.1306 12.8723 21.0659 12.6391 21.1682 12.4549C21.2704 12.2708 21.5012 12.2054 21.6834 12.3087C21.8855 12.4234 22.1519 12.6409 22.2731 13.025C22.39 13.3945 22.3342 13.7134 22.2667 13.9161H22.267Z"
                                                fill="#FFB1B5"
                                              />
                                              <path
                                                d="M19.8402 19.2491C19.8402 19.2491 19.8399 19.2482 19.8396 19.2479C19.3881 18.1146 18.5759 17.286 17.491 16.8517C15.7786 16.1663 13.7677 16.5778 12.4567 17.1919C9.24652 18.6954 8.78897 21.4339 9.26453 22.9075C9.6003 23.9476 10.3741 24.5602 11.3011 24.5602C11.4449 24.5602 11.5926 24.5454 11.7428 24.5152C12.6194 24.3388 13.1899 23.9553 13.7418 23.5843C14.5137 23.0654 15.3116 22.5287 17.1248 22.4016C18.3997 22.3121 19.2681 21.9269 19.7059 21.256C19.9207 20.9265 20.0218 20.5317 20.0074 20.102C19.9986 19.8343 19.9452 19.5532 19.846 19.2661C19.8441 19.2605 19.842 19.255 19.8399 19.2494L19.8402 19.2491ZM17.2063 19.2802C16.5066 18.5615 15.4188 18.5254 15.4078 18.5251C15.1993 18.5199 15.0339 18.345 15.0384 18.1343C15.043 17.9236 15.2106 17.758 15.4237 17.7604C15.4804 17.7617 16.8259 17.799 17.7456 18.7438C17.8921 18.8944 17.8903 19.1365 17.7413 19.2846C17.6678 19.358 17.5716 19.3944 17.4761 19.3944C17.3805 19.3944 17.2804 19.3561 17.2063 19.2802ZM18.2099 20.8321C18.1916 20.8349 18.1733 20.8361 18.1549 20.8361C17.97 20.8361 17.8082 20.6989 17.781 20.5086C17.7691 20.4253 17.7535 20.3435 17.7349 20.2658C17.6858 20.0604 17.8106 19.854 18.0139 19.8043C18.2169 19.7547 18.4217 19.8808 18.4706 20.0863C18.4947 20.1871 18.5145 20.2923 18.5301 20.3987C18.56 20.6079 18.4168 20.8019 18.2099 20.8321Z"
                                                fill="#FFB1B5"
                                              />
                                              <path
                                                d="M56.7065 22.9221C48.0801 17.5894 36.9624 16.1815 24.9011 18.8393C25.3868 19.6215 25.7811 20.5676 25.8391 21.6219C28.6766 21.1475 32.6634 20.7437 37.1293 21.0695C42.5028 21.4609 46.5804 23.3422 49.5577 24.7158C51.4991 25.6113 53.0323 26.3189 54.2514 26.3525C55.4034 26.3846 56.1088 26.1656 56.6875 25.5971C57.0795 25.2121 57.3206 24.5008 57.2608 23.9052C57.2306 23.6038 57.1085 23.1914 56.7071 22.9224L56.7065 22.9221Z"
                                                fill="#9DD9AF"
                                              />
                                              <path
                                                d="M41.582 7.17397C34.4785 7.42136 28.6228 8.86929 24.9187 10.06C25.7456 11.0822 26.1027 12.4641 26.0762 13.3121C29.4924 12.3923 34.8118 11.3416 41.3888 11.3C48.065 11.2587 53.255 12.5693 56.4341 13.6767C59.2258 14.6493 61.5648 15.8551 62.9561 17.0053C64.7063 17.7716 66.2973 17.398 66.8326 16.5831C67.249 15.9498 67.2813 14.7462 66.3693 13.6002C64.0251 10.6547 54.7845 6.71313 41.5817 7.17367L41.582 7.17397Z"
                                                fill="#9DDEF7"
                                              />
                                              <path
                                                d="M24.0272 9.24751C24.0831 9.28298 24.135 9.32309 24.1884 9.36164C27.9245 8.12439 34.0574 6.54259 41.5516 6.28163C49.2488 6.01357 54.9562 7.21535 58.3886 8.27061C59.6557 8.6602 60.8443 9.10315 61.9218 9.58127C61.9315 9.58466 61.9413 9.58621 61.9508 9.59022C61.9679 9.59762 63.7169 10.3247 64.8542 9.88264C65.7717 9.52605 66.1411 9.01308 66.2168 7.9899C66.2681 7.29524 65.86 6.50619 65.0361 5.70819C60.4111 1.22898 49.1347 0.27953 40.6145 1.29253C31.7351 2.3484 25.2051 5.02093 21.2904 7.07685C20.5875 7.44608 19.9428 7.80884 19.354 8.15771C19.466 8.47388 19.5384 8.77063 19.5829 9.01801C21.3085 8.21261 23.0172 8.60405 24.0269 9.24751H24.0272Z"
                                                fill="#A1FCE7"
                                              />
                                              <path
                                                d="M56.1466 14.5204C53.0326 13.4355 47.9458 12.1499 41.3947 12.1924C34.6556 12.235 29.274 13.3458 25.9453 14.2699C25.5604 15.8295 24.4323 16.6963 23.4778 17.0955C23.733 17.3413 24.0388 17.6634 24.3447 18.0492C36.7633 15.2336 48.2394 16.6491 57.1478 22.1481C57.1536 22.1515 57.1597 22.1534 57.1652 22.1571C57.1722 22.1617 57.1783 22.1669 57.1851 22.1716C57.4918 22.3613 57.7955 22.5559 58.0959 22.7552C58.1988 22.8237 58.2851 22.881 58.355 22.9258C59.8916 23.915 61.6675 23.6837 62.7212 23.1849C63.2642 22.9279 63.7196 22.3233 63.9101 21.6071C64.1662 20.6437 63.9302 19.5654 63.2456 18.5709C62.5869 17.6137 60.3324 15.9788 56.146 14.5204H56.1466Z"
                                                fill="#FFE66A"
                                              />
                                              <path
                                                d="M23.993 19.0457C23.7961 18.7585 23.5886 18.4994 23.3883 18.2736C22.8267 17.6406 22.3276 17.2662 22.3206 17.2609C22.1771 17.1548 22.1106 16.9722 22.1518 16.7973C22.193 16.623 22.3328 16.4907 22.5074 16.4608C22.5926 16.446 24.2463 16.1363 24.9185 14.5674C25.0424 14.2778 25.1334 13.9455 25.1746 13.564C25.1834 13.4829 25.1898 13.3993 25.1941 13.3135C25.232 12.5214 24.8345 11.1848 24.0025 10.3634C23.8651 10.2279 23.7174 10.1049 23.5565 10.0025C23.4103 9.90929 23.2455 9.82292 23.0657 9.74766C22.1271 9.35406 20.7739 9.26245 19.4544 10.103C19.3189 10.1891 19.1482 10.1946 19.0075 10.1172C18.8671 10.0398 18.7789 9.89171 18.7774 9.73008C18.7768 9.68874 18.7645 9.21741 18.5817 8.62701C18.5008 8.36543 18.3864 8.08103 18.224 7.79971C17.9444 7.3148 17.5238 6.84069 16.8901 6.51526C15.881 5.99704 13.7241 5.75181 12.2312 7.30092C11.2724 8.29572 11.1595 9.57831 11.1586 9.59096C11.1442 9.76925 11.0261 9.92163 10.8579 9.97839C10.6901 10.0348 10.5048 9.98456 10.3876 9.85069C10.3543 9.81367 9.5219 8.90031 8.04882 8.90031C5.73541 8.90031 4.54711 10.4408 4.20952 11.3511C3.49495 13.2793 4.44363 14.82 4.4531 14.8355C4.53734 14.9693 4.54497 15.1384 4.47324 15.2793C4.40121 15.4203 4.2608 15.5122 4.1039 15.5206C4.03217 15.5249 2.30238 15.6464 1.40254 17.231C0.603419 18.6379 0.692549 20.8231 2.22943 21.9005C3.37011 22.7001 5.12585 22.4354 5.8282 22.2846C5.85873 22.2781 5.88955 22.2747 5.92008 22.2747C6.02966 22.2747 6.13649 22.316 6.21891 22.3922C6.32421 22.49 6.37611 22.6331 6.3581 22.7766C6.32971 23.0079 5.70946 28.4576 9.85156 29.043C12.3802 29.4005 13.7183 28.1716 14.7931 27.1839C15.211 26.8002 15.6056 26.4374 16.022 26.2116C16.5448 25.9282 17.4099 25.9201 18.5048 25.9103C20.7642 25.8893 23.576 25.8631 24.5974 23.5604C24.724 23.2751 24.8165 22.9873 24.8782 22.6979C24.9432 22.3922 24.9716 22.0847 24.9646 21.7753C24.945 20.9141 24.6483 20.0396 24.0711 19.1598C24.0455 19.1207 24.0189 19.0833 23.993 19.0454V19.0457ZM19.7285 12.0966C19.8698 11.9307 20.0353 11.794 20.2166 11.686C20.4711 11.5343 20.7575 11.4408 21.0609 11.4183C21.1149 11.4143 21.1686 11.4137 21.2223 11.4143C21.6832 11.4177 22.1243 11.583 22.4775 11.8909C22.8718 12.2345 23.1102 12.7126 23.1487 13.2373C23.1762 13.6109 23.0959 13.9671 22.9378 14.2784C22.6811 14.7836 22.2147 15.1658 21.6454 15.2994C21.5489 15.3219 21.4503 15.3398 21.3487 15.3475C21.2996 15.3512 21.2504 15.3531 21.2016 15.3531C20.7349 15.3531 20.2889 15.1862 19.9318 14.8753C19.5374 14.5316 19.299 14.0535 19.2606 13.5288C19.2221 13.0041 19.3882 12.4958 19.7279 12.0972L19.7285 12.0966ZM14.8914 8.66402C15.4029 8.62547 15.9014 8.76489 16.3168 9.05793C16.3791 9.10204 16.4398 9.14893 16.4981 9.19983C16.6709 9.35036 16.8168 9.52433 16.934 9.71496C17.1199 10.0173 17.2329 10.3621 17.2594 10.727C17.3031 11.3221 17.1147 11.8989 16.7292 12.3508C16.3437 12.8027 15.8071 13.076 15.218 13.1201C15.1621 13.1244 15.1066 13.1263 15.051 13.1263C14.522 13.1263 14.0159 12.9369 13.6112 12.5843C13.164 12.1947 12.8936 11.6524 12.8499 11.0571C12.7599 9.82848 13.6753 8.75502 14.8911 8.66402H14.8914ZM6.1136 20.3502C5.77356 20.7487 5.30044 20.9896 4.78123 21.0285C4.73209 21.0322 4.68294 21.0341 4.6341 21.0341C4.1677 21.0341 3.72144 20.8672 3.36461 20.5562C2.97024 20.2126 2.73185 19.7345 2.69339 19.2098C2.65493 18.6851 2.82098 18.1768 3.16102 17.7779C3.50106 17.3794 3.97418 17.1385 4.49339 17.0996C5.56386 17.0197 6.50186 17.8353 6.58123 18.9183C6.61969 19.443 6.45364 19.9514 6.1139 20.3502H6.1136ZM8.24234 15.6973C7.71336 15.6973 7.20727 15.5079 6.80253 15.1553C6.35535 14.7658 6.08491 14.2235 6.04126 13.6281C5.95121 12.3995 6.86693 11.3261 8.08239 11.2351C8.6709 11.191 9.242 11.3813 9.68917 11.7709C10.1363 12.1605 10.4068 12.7031 10.4504 13.2981C10.4941 13.8931 10.3058 14.4699 9.92024 14.9218C9.53472 15.3737 8.99811 15.647 8.409 15.6911C8.35314 15.6955 8.29759 15.6973 8.24203 15.6973H8.24234ZM19.7059 21.2568C19.2682 21.9277 18.3998 22.313 17.1248 22.4024C15.3117 22.5295 14.5135 23.0662 13.7418 23.5851C13.19 23.9561 12.6195 24.3396 11.7428 24.516C11.5926 24.5462 11.4449 24.561 11.3011 24.561C10.3741 24.561 9.60035 23.9484 9.26458 22.9083C8.78902 21.4348 9.24658 18.6962 12.4568 17.1928C13.7678 16.5786 15.7787 16.1671 17.4911 16.8525C18.5762 17.2868 19.3882 18.1154 19.8396 19.2487C19.8396 19.2493 19.8399 19.2496 19.8402 19.2499C19.8423 19.2555 19.8445 19.261 19.8463 19.2666C19.9455 19.5537 19.9989 19.8347 20.0078 20.1025C20.0221 20.5322 19.9211 20.927 19.7062 21.2565L19.7059 21.2568Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M5.54075 18.3792C5.20835 17.9652 4.7337 17.934 4.68059 17.9319C4.47363 17.9245 4.29232 18.087 4.28378 18.2983C4.27523 18.5093 4.43456 18.6873 4.64335 18.6959C4.65098 18.6966 4.83351 18.7126 4.95317 18.8616C5.11647 19.0652 5.08839 19.2891 5.08808 19.2919C5.05206 19.4998 5.18973 19.6982 5.39546 19.7345C5.41743 19.7386 5.43972 19.7404 5.46139 19.7404C5.53343 19.7404 5.60149 19.7188 5.6601 19.6821C5.74831 19.6266 5.81425 19.5356 5.83378 19.4239C5.83897 19.3937 5.86186 19.2364 5.82798 19.0257C5.79746 18.836 5.72054 18.6028 5.54106 18.3792H5.54075Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M8.4474 12.0783C8.23954 12.0564 8.04907 12.2087 8.0277 12.4191C8.00633 12.6292 8.15315 12.8164 8.36102 12.8383C8.36926 12.8396 8.56645 12.8726 8.74074 13.094C8.85154 13.2347 8.87993 13.4667 8.88145 13.5416C8.88298 13.752 9.05208 13.9213 9.25995 13.9213H9.2627C9.47179 13.9198 9.63997 13.7474 9.63845 13.5361C9.63814 13.4812 9.62593 12.9898 9.3329 12.6178C8.9599 12.1446 8.49868 12.0838 8.4474 12.0786V12.0783Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M15.2121 10.3408C15.2146 10.3411 15.4679 10.388 15.5745 10.6181C15.5876 10.6462 15.5974 10.6736 15.6059 10.7008C15.6709 10.9087 15.6129 11.0774 15.612 11.0799C15.5336 11.2758 15.6273 11.4985 15.8211 11.5777C15.8675 11.5969 15.9157 11.6058 15.9627 11.6058C16.1123 11.6058 16.2542 11.5154 16.3138 11.3668C16.3348 11.3143 16.5119 10.8377 16.26 10.2942C16.249 10.2702 16.2347 10.2504 16.2225 10.2279C16.0448 9.90093 15.7555 9.71986 15.5232 9.6372C15.4475 9.61036 15.3776 9.59247 15.3205 9.58414C15.1145 9.5536 14.9216 9.69858 14.8916 9.90772C14.8816 9.97897 14.8926 10.0478 14.9182 10.1095C14.968 10.2291 15.0754 10.3211 15.2118 10.3411L15.2121 10.3408Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M21.3127 12.9757C21.4345 13.0448 21.5151 13.1395 21.5524 13.2576C21.6094 13.4387 21.5753 13.5948 21.5496 13.6719C21.4828 13.8721 21.5893 14.0889 21.7874 14.1565C21.8274 14.17 21.8683 14.1765 21.9083 14.1765C22.0664 14.1765 22.2135 14.0757 22.2669 13.9162C22.3344 13.7138 22.3902 13.3949 22.2733 13.025C22.1518 12.641 21.8857 12.4235 21.6836 12.3088C21.5014 12.2054 21.2706 12.2708 21.1684 12.455C21.0661 12.6391 21.1308 12.8723 21.3131 12.9757H21.3127Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M18.4702 20.0877C18.421 19.8822 18.2162 19.7561 18.0135 19.8057C17.8106 19.8554 17.6854 20.0621 17.7346 20.2672C17.7532 20.3449 17.7687 20.4267 17.7806 20.51C17.8078 20.7003 17.9696 20.8375 18.1546 20.8375C18.1726 20.8375 18.1909 20.8363 18.2095 20.8335C18.4165 20.8033 18.5596 20.6093 18.5297 20.4001C18.5144 20.2937 18.4946 20.1885 18.4702 20.0877Z"
                                                fill="white"
                                              />
                                              <path
                                                d="M17.7456 18.7451C16.8256 17.8003 15.4804 17.7627 15.4236 17.7617C15.2106 17.7593 15.043 17.9246 15.0384 18.1356C15.0336 18.3463 15.199 18.5212 15.4078 18.5264C15.4188 18.5267 16.5066 18.5628 17.2062 19.2816C17.2804 19.3577 17.3781 19.3957 17.4761 19.3957C17.5741 19.3957 17.6678 19.3593 17.7413 19.2859C17.8903 19.1378 17.8921 18.8957 17.7456 18.7451Z"
                                                fill="white"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_5_2746">
                                                <rect width="68" height="30" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          HypurrFi points
                                        </Tag>
                                      )}
                                      {isKEIPoints && (
                                        <Tag
                                          variant={3}
                                          style={{ background: 'rgb(178, 242, 253)', minWidth: 'unset' }}
                                        >
                                          <img
                                            src={KeikoLogo}
                                            style={{ width: '14px', borderRadius: '100px', marginRight: '2px' }}
                                            alt="kei logo"
                                          />
                                          KEIKO points
                                        </Tag>
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: '130px' }}
                                  >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                      <TokenLogo token={pool.token0.token0Address} />
                                      <span style={{ fontSize: '14px' }}>
                                        {roundToDecimalPlace(
                                          `${formatUnits(pool.reserves.reserve0, pool.token0.token0Decimal)}`,
                                          '2'
                                        )}{' '}
                                      </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                      <TokenLogo token={pool.token1.token1Address} />
                                      <span style={{ fontSize: '14px' }}>
                                        {roundToDecimalPlace(
                                          `${formatUnits(pool.reserves.reserve1, pool.token1.token1Decimal)}`,
                                          '2'
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td
                                  style={{ textAlign: 'center', fontSize: '12px', fontWeight: 500, minWidth: '70px' }}
                                >
                                  {pool.apr ? `${roundToDecimalPlace(`${pool.apr}`, '2')}%` : 'N/A'}
                                </td>
                                <td
                                  style={{ textAlign: 'center', fontSize: '12px', fontWeight: 500, minWidth: '120px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '2px',
                                    }}
                                  >
                                    {volumeIncreasingIcon && volumeIncreasingIcon}{' '}
                                    {pool.h24 ? `$${roundToDecimalPlace(`${pool.h24}`, '2')}` : 'N/A'}
                                  </div>
                                </td>
                                <td
                                  style={{ textAlign: 'center', fontSize: '12px', fontWeight: 500, minWidth: '100px' }}
                                >
                                  {pool.totalTvlUSD ? `$${roundToDecimalPlace(`${pool.totalTvlUSD}`, '2')}` : 'N/A'}
                                </td>
                                <td
                                  style={{
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '4px',
                                    minWidth: '104px',
                                  }}
                                >
                                  <TagButton
                                    onClick={() => {
                                      history.push(addV2LPRoute)
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="icon icon-tabler icons-tabler-outline icon-tabler-plus"
                                    >
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M12 5l0 14" />
                                      <path d="M5 12l14 0" />
                                    </svg>
                                    Add Liq.
                                  </TagButton>
                                  <TagButton
                                    onClick={() => {
                                      history.push(swapRoute)
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="icon icon-tabler icons-tabler-outline icon-tabler-repeat"
                                    >
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
                                      <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
                                    </svg>
                                    Swap
                                  </TagButton>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </TableWrapper>
                      <PaginationContainer>
                        <ButtonSecondary onClick={() => handlePageChange(0)} disabled={currentPage === 0}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-left"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M11 7l-5 5l5 5" />
                            <path d="M17 7l-5 5l5 5" />
                          </svg>
                        </ButtonSecondary>

                        <ButtonSecondary onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M15 6l-6 6l6 6" />
                          </svg>
                        </ButtonSecondary>

                        <span>
                          Page {currentPage + 1}/{pageCount}{' '}
                        </span>

                        <ButtonSecondary
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage + 1 >= pageCount}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M9 6l6 6l-6 6" />
                          </svg>
                        </ButtonSecondary>
                        <ButtonSecondary
                          onClick={() => handlePageChange(pageCount - 1)}
                          disabled={currentPage + 1 >= pageCount}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7 7l5 5l-5 5" />
                            <path d="M13 7l5 5l-5 5" />
                          </svg>
                        </ButtonSecondary>
                      </PaginationContainer>
                    </>
                  )}
                </div>
              ) : (
                <MainContentWrapper>
                  <NoLiquidity>
                    <TYPE.mediumHeader color={theme.text3} textAlign="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-photo-hexagon"
                        style={{ marginBottom: '.5rem' }}
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M15 8h.01" />
                        <path d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
                        <path d="M3.5 15.5l4.5 -4.5c.928 -.893 2.072 -.893 3 0l5 5" />
                        <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2.5 2.5" />
                      </svg>
                      <div>Pools not found.</div>
                    </TYPE.mediumHeader>
                  </NoLiquidity>
                </MainContentWrapper>
              )}
            </>
          </AutoColumn>
        </AutoColumn>
      </PageWrapper>
    </>
  )
}
export default ExplorePools
